import SectionMessage from '@atlaskit/section-message';
import Image from '@atlaskit/image';
import objectTileAnatomyDark from "../../../../../../packages/design-system/object/constellation/object-tile/images/object-tile-anatomy-dark.png";
import objectTileAnatomyLight from "../../../../../../packages/design-system/object/constellation/object-tile/images/object-tile-anatomy-light.png";
import objectTileSizeDark from "../../../../../../packages/design-system/object/constellation/object-tile/images/object-tile-size-dark.png";
import objectTileSizeLight from "../../../../../../packages/design-system/object/constellation/object-tile/images/object-tile-size-light.png";
import objectTileColorsDo from "../../../../../../packages/design-system/object/constellation/object-tile/images/do-donts/object-tile-colors-do.png";
import objectTileColorsDont from "../../../../../../packages/design-system/object/constellation/object-tile/images/do-donts/object-tile-colors-dont.png";
import objectTileSmallerDo from "../../../../../../packages/design-system/object/constellation/object-tile/images/do-donts/object-tile-smaller-do.png";
import objectTileSmallerDont from "../../../../../../packages/design-system/object/constellation/object-tile/images/do-donts/object-tile-smaller-dont.png";
import * as React from 'react';
export default {
  SectionMessage,
  Image,
  objectTileAnatomyDark,
  objectTileAnatomyLight,
  objectTileSizeDark,
  objectTileSizeLight,
  objectTileColorsDo,
  objectTileColorsDont,
  objectTileSmallerDo,
  objectTileSmallerDont,
  React
};